// import _ from 'lodash'
import request from '@/utils/request'

const prefix = '/django_rest/company/management'
const clientAdminPrefix = '/django_rest/client-admin'

export default {
  getCompany (companyId) {
    return request.get(`${prefix}/${companyId}/`)
  },
  updateCompany (companyId, companyData) {
    return request.put(`${prefix}/${companyId}/`, companyData)
  },
  addCompany (companyData) {
    return request.post(`${prefix}/`, companyData)
  },
  deleteCompany (companyId) {
    return request.delete(`${prefix}/${companyId}/`)
  },
  parentCompanyValidate (params) {
    return request.get(`${prefix}/validate/parent-company/`, { params })
  },
  getCompanyPremiumInfo (companyId) {
    return request.get(`/django_rest/company/${companyId}/premium-management/`)
  },
  saveCompanyPremium (premiumInfo) {
    return request.post(`/django_rest/company/${premiumInfo.company_id}/premium-management/`, premiumInfo)
  },
  getCompanyApprovalList (params) {
    return request.get(`${clientAdminPrefix}/company-approval/`, { params })
  },
  updateCompanyApprovalStatus (params) {
    return request.put(`${clientAdminPrefix}/company-approval-change-status/`, params)
  },
  getCompanyApprovalInfo (companyId) {
    return request.get(`${clientAdminPrefix}/company-approval/${companyId}/`)
  },
  getCompanyApprovalEditInfo (companyId) {
    return request.get(`${clientAdminPrefix}/company-approval-edit/${companyId}/`)
  },
  updateCompanyApprovalInfo (companyId, data) {
    return request.put(`${clientAdminPrefix}/company-approval-edit/${companyId}/`, data)
  },
  getCompanyProfileInfo (params) {
    return request.get(`${clientAdminPrefix}/company-profile/`, { params })
  },
  updateCompanyProfileInfo (data) {
    return request.put(`${clientAdminPrefix}/company-profile/`, data)
  }
}
